import { useTranslation } from "react-i18next"
import { TextWithTooltip } from "@/components/text-with-tooltip"
import { Badge } from "@/components/ui/badge"
import { formatDateForAppointment } from "@/lib/format-date"
import { WaitingRoomAppointments } from "@/modules/waiting-room/services/WaitingRoomAppointmentsQuery"

type AppointmentGroupHeaderContentProps = {
  numberOfAppointmentsInGroup: number[]
  index: number
  appointmentGroups: WaitingRoomAppointments
}

export const AppointmentGroupHeaderContent = ({
  numberOfAppointmentsInGroup,
  index,
  appointmentGroups,
}: AppointmentGroupHeaderContentProps) => {
  const { t } = useTranslation()
  const columnHeaders = [
    t("scheduling.waitingRoom.grid.columnName.interval"),
    t("scheduling.waitingRoom.grid.columnName.sla"),
    t("scheduling.waitingRoom.grid.columnName.priority"),
    t("scheduling.waitingRoom.grid.columnName.assignedTo"),
    t("scheduling.waitingRoom.grid.columnName.language"),
    t("scheduling.waitingRoom.grid.columnName.patient"),
    t("scheduling.waitingRoom.grid.columnName.patientId"),
    t("scheduling.waitingRoom.grid.columnName.channel"),
    t("scheduling.waitingRoom.grid.columnName.access"),
    t("scheduling.waitingRoom.grid.columnName.service"),
    t("scheduling.waitingRoom.grid.columnName.specialty"),
    t("scheduling.waitingRoom.grid.columnName.reasonForEncounter"),
    t("scheduling.waitingRoom.grid.columnName.status"),
  ]

  return (
    numberOfAppointmentsInGroup[index] > 0 && (
      <div className="table-info-container bg-background-subdued">
        <div className="bg-background-subdued flex h-10 items-center gap-2">
          <div className="text-on-surface text-base font-medium" data-testid="appointment-title">
            {formatDateForAppointment(appointmentGroups[index].date, {
              todayText: t("scheduling.waitingRoom.grid.today"),
              yesterdayText: t("scheduling.waitingRoom.grid.yesterday"),
              tomorrowText: t("scheduling.waitingRoom.grid.tomorrow"),
            })}
          </div>
          <Badge
            className="bg-surface-subdued text-on-surface-subdued h-5 min-w-5 p-1 leading-4 font-normal"
            data-testid="appointment-count">
            {numberOfAppointmentsInGroup[index]}
          </Badge>
        </div>
        <div className="table-header-container bg-background-subdued col-span-full h-auto leading-4">
          <div
            data-testid="table-header-container"
            className="grid-cols-appointment border-border bg-surface text-on-surface-subdued grid gap-4 rounded-t-xl border px-4 py-2 text-xs tracking-[0.25px]">
            {columnHeaders.map((header) => (
              <TextWithTooltip key={header} data-testid="table-header">
                {header}
              </TextWithTooltip>
            ))}
          </div>
        </div>
      </div>
    )
  )
}
